import type { StravaStatus } from '@painpal/contracts';
import { formatRelative } from '../lib/format';
import { importCounts } from '../lib/strava';

export function initials(name: string): string {
  const letters = name.trim().split(/\s+/).filter((word) => word !== '').slice(0, 2).map((word) => word.charAt(0).toUpperCase()).join('');
  return letters === '' ? '?' : letters;
}

export interface SyncPill { tone: 'green' | 'amber' | 'hot'; text: string }

export function syncPill(strava: StravaStatus | undefined, now: Date): SyncPill | null {
  if (strava === undefined || !strava.connected) return null;
  if (strava.status === 'revoked') return { tone: 'hot', text: 'RECONNECT' };
  const backfill = strava.backfill;
  if (backfill !== null && backfill.status === 'running') return { tone: 'amber', text: `IMPORTING ${importCounts(backfill, '/')}` };
  if (strava.lastSyncAt === null) return { tone: 'green', text: 'CONNECTED' };
  return { tone: 'green', text: `SYNCED ${formatRelative(strava.lastSyncAt, now)}` };
}
